<template>
  <SettingsSection>
    <SettingsSectionTitle>Delete account</SettingsSectionTitle>
    <SettingsSectionDescription>
      <div style="margin-bottom: 5px">
        If you would like to delete your account, please reach out to us at the email address <span class="settingsAreaDanger__email"> support@cofocus.one</span> and we will delete your account within 48 hours.
      </div>
    </SettingsSectionDescription>
  </SettingsSection>
</template>

<script>
import SettingsSection from "./SettingsSection.vue";
import SettingsSectionTitle from "./SettingsSectionTitle.vue";
import SettingsSectionDescription from "./SettingsSectionDescription.vue";

export default {
  components: {
    SettingsSection,
    SettingsSectionTitle,
    SettingsSectionDescription,
  },
};
</script>

<style scoped>
.settingsAreaDanger__email {
  font-weight: 600;
}
</style>
